import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetTutorialCounter } from "../componentLibrary/TutorialTip";

/**
 * Hook to reset tutorial counter when navigating between pages
 * This ensures tutorial numbering starts fresh on each page
 */
export const useTutorialCounter = () => {
  const location = useLocation();

  useEffect(() => {
    // Reset tutorial counter when location changes
    resetTutorialCounter();
  }, [location.pathname]);
};
